import React from "react";
import { DOMAIN } from "../../utils/constant";
class UploadImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { file: null };
    this.onChange = this.onChange.bind(this);
    this.defaultImage = "https://scdaily.com/resources/cloud-upload-light.png";
  }
  onChange(e) {
    let file = e.target.files[0];
    this.props.onChange(file);
    this.setState({
      file: URL.createObjectURL(file)
    });
  }
  render() {
    return (
      <div className="upload_image_wrap">
        <input
          type="file"
          onChange={this.onChange}
          accept="image/x-png,image/gif,image/jpeg"
        />
        <div
          className="image"
          accept="image/*"
          style={{
            backgroundImage: `url(${
              this.state.file
                ? this.state.file
                : this.props.src
                ? DOMAIN + this.props.src
                : this.defaultImage
            })`
          }}
        ></div>
        <button
          type="button"
          style={{ cursor: "pointer" }}
          block={true}
          className="btn btn-default mt-2"
        >
          上傳圖片
        </button>
      </div>
    );
  }
}
export default UploadImage;
